import { useEffect, useMemo } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import {
  useBuilderContext,
  useComponentsContext,
  useBuilderConfigContext,
} from 'hb-builder/hooks';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const Drag = ({ children, component }) => {
  const { getBodyItem } = useBuilderContext();
  const { components } = useComponentsContext();
  const {
    componentTheme,
    features,
    hivebrite: { ids, networkFont },
    type,
  } = useBuilderConfigContext();
  const featureFlags = useFeatureFlag();
  const bodyWidth = getBodyItem()?.attributes?.bodyWidth;

  const item = useMemo(
    () => ({
      ...(typeof component?.item === 'function' && components
        ? component.item({
            bodyWidth,
            components,
            features,
            featureFlags,
            ids,
            networkFont,
            theme: componentTheme,
            builderType: type,
          })
        : component.item),
    }),
    [
      bodyWidth,
      component,
      components,
      componentTheme,
      ids,
      featureFlags,
      features,
      networkFont,
      type,
    ],
  );

  const [{ isDragging }, dragRef, preview] = useDrag({
    item: {
      label: component.label,
      type: component.type,
      item,
    },
    type: component.type,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return children({ ref: dragRef, isDragging });
};

export default Drag;
